import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BaseInterviewFormFieldComponent, BaseFormFieldServices } from '../base-interview-form-field/base-interview-form-field.component';
import { FieldDetailsComponent } from '@Components/field-details/field-details.component';
import {MaskitoDirective} from '@maskito/angular';
import {MaskitoOptions} from '@maskito/core';
import { InterviewProcessingStatusComponent } from '@App/interview/components/interview-processing-status/interview-processing-status.component';

@Component({
    selector: 'phone-number-answer',
    templateUrl: './phone-number-answer.component.html',
    styleUrls: ['./phone-number-answer.component.scss'],
    imports: [SharedModule, FieldDetailsComponent, MaskitoDirective, InterviewProcessingStatusComponent]
})

export class PhoneNumberAnswerComponent extends BaseInterviewFormFieldComponent implements OnInit {
    extension: any = '';
    maskitoOptions: MaskitoOptions = {
        mask:  [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    };

    constructor(private fb: UntypedFormBuilder,
        public services: BaseFormFieldServices) {

        super(services);
    }

    ngOnInit() {
        const extensionFormField = `ext${this.config.id}`;
        this.group.addControl(extensionFormField, this.fb.control(''));

        const currentAnswerValue = this.group.get(this.config.id).value;
        let extensionValue = '';
        let finalAnswerValue = '';

        // if value>12, then phonenumber has extension, whose input value is filled by splitting the answer value.
        if (currentAnswerValue.length > 12) {
            const answerValueSplit = currentAnswerValue.split('-');

            answerValueSplit.forEach((eachSplit, index) => {
                if (index < 3) {
                    finalAnswerValue = finalAnswerValue ? finalAnswerValue + '-' + eachSplit : eachSplit;
                } else {
                    extensionValue = eachSplit;
                }
            });
        }

        if (finalAnswerValue) {
            this.group.get(this.config.id).setValue(finalAnswerValue);
        }

        if (extensionValue) {
            this.group.get('ext' + this.config.id).setValue(extensionValue);
        }

        super.initialize({
            inputType: 'text',
            additionalFormFieldNames: [extensionFormField],
            additionalValidators: [
                Validators.pattern(/^\d{3}-?\d{3}-?\d{4}$/)
            ]
        });
    }
}
